/**
 * @desc 新增
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.ProductSizeSectionRequestParamsDto>, options?: any) {
  return updateResponse(
    http(URL + `/ProductSizeSection/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
